import { createSlice } from "@reduxjs/toolkit";

const LastPageSession = createSlice({
  name: "LastPageSession",
  initialState: "",
  reducers: {
    saveLastPageSession: (state, action) => action.payload,
  },
});

export default LastPageSession;
